module.exports = __webpack_public_path__ + "static/media/prison.3878fb28.jpg";